import { AuctionOrder, OrderType, TimedAuctions } from "@/api/orders/types";
import { isExpiredInSeconds } from "@/shared/dates";
import useIsMounted from "@/shared/hooks/useIsMounted";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import ExpiredCountdown from "./ExpiredCountdown";

import styles from "./TradeCountdown.module.css";
import { useRouter } from "next/navigation";
import { useTransition } from "react";

export interface Props {
  auction?: AuctionOrder;
}

export default function TradeCountdown({ auction }: Props) {
  const [, startTransition] = useTransition();
  const isComponentMounted = useIsMounted();
  const { refresh } = useRouter();

  let isReserveAuction = auction?.type === OrderType.RESERVE_AUCTION;
  let isExpired = isExpiredInSeconds(auction?.expiresAt);

  if (
    !auction ||
    !TimedAuctions.includes(auction.type!) ||
    !auction.startingAt ||
    !auction.expiresAt
  ) {
    isReserveAuction = false;
    isExpired = true;
  }

  if (!isReserveAuction && isExpired) {
    return null;
  }

  return (
    <div className="absolute -top-24 left-[50%] -translate-x-2/4">
      <div className="text-center mb-6">{`Auction ${
        !isExpired ? "ends in" : "finished"
      }`}</div>
      {isExpired ? <ExpiredCountdown /> : null}
      {!isExpired && isComponentMounted && (
        <FlipClockCountdown
          className={styles.flipClockCountdown}
          labels={["Days", "Hrs", "Mins", "Secs"]}
          showSeparators
          digitBlockStyle={{ border: "2px solid #000000", marginRight: "0px" }}
          to={auction!.expiresAt! * 1000}
          duration={0.9}
          onComplete={() => {
            startTransition(refresh);
          }}
        />
      )}
    </div>
  );
}
